import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import * as yup from 'yup';
import { Feedback } from '@availity/form';
import {
    defaultTimelineAction,
    TimelineAction,
} from '../../../../slices/marketplace/timeline/models/timeline-actions.model';
import { TimelineEvent } from '../../../../slices/marketplace/timeline/models/timeline-event.model';
import { TimelineActionType } from '../../../../slices/marketplace/timeline/models/timeline-action-type.model';
import { Formik } from 'formik';
import '../TimelineActionYupValidator';

interface SellerProfileFormProps {
    onSubmit(action: TimelineAction): void;
    disabled: boolean;
    timelineEvents: TimelineEvent[];
    currentEvent: TimelineEvent;
    linkedAction?: TimelineAction;
}

export const SellerProfileForm = forwardRef(
    (props: SellerProfileFormProps, ref) => {
        const formRef = useRef<any>();

        useImperativeHandle(ref, () => ({
            handleSubmit() {
                formRef?.current?.handleSubmit();
            },
        }));

        return (
            <Formik
                innerRef={formRef}
                initialValues={{
                    actionType:
                        props.linkedAction?.actionType ===
                        TimelineActionType.SellerProfile
                            ? props.linkedAction.actionType
                            : TimelineActionType.SellerProfile,
                }}
                validationSchema={yup.object().shape({
                    actionType: yup
                        .number()
                        .uniqueActionValidation(
                            props.timelineEvents ?? [],
                            props.currentEvent
                        ),
                })}
                onSubmit={(values) => {
                    props.onSubmit({
                        ...defaultTimelineAction,
                        actionType: Number(values.actionType),
                    });
                }}>
                {() => <Feedback name="actionType" />}
            </Formik>
        );
    }
);
